module.exports = __webpack_public_path__ + "static/media/border.54d06e0e.jpg";